import React from 'react';

import { Badge } from '@rover/kibble/official-patterns/Badge';

export type Props = { label: string };

const SkillTag = ({ label }: Props): React.ReactElement => <Badge variant="success" text={label} />;

export default SkillTag;
